<div class="wrapper" [class.isInvalid]="getIsInvalid()">
  <input type="radio" [name]="name" [attr.checked]="getIsChecked()" (change)="onInputChange($event.target.checked)">

  <div class="uncheck"></div>

  <div class="check">
    <div class="dot"></div>
  </div>
</div>
